<template>
  <div
    v-if="initialized"
    class="wrapper"
    :class="{ 'nav-open': $sidebar.showSidebar }"
  >
    <side-bar>
      <template slot-scope="props" slot="links">
        <!-- <sidebar-item
          v-if="$can('read', 'DASHBOARD')"
          :link="{
            name: 'Dashboard',
            icon: 'now-ui-icons design_app',
            path: '/dashboard'
          }"
        /> -->
        <sidebar-item
          v-if="$can('read', 'BOOKINGS')"
          :link="{
            name: $t('message.bookings'),
            icon: 'now-ui-icons ui-1_calendar-60',
            path: '/bookings'
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$can('read', 'ACTIVITY')"
          :link="{
            name: 'Activity',
            icon: 'now-ui-icons media-2_sound-wave',
            path: '/activity'
          }"
        />
        <sidebar-item
          v-if="$can('read', 'MANAGEMENT')"
          :link="{
            name: $t('message.management'),
            icon: 'now-ui-icons business_badge'
          }"
        >
          <sidebar-item
            v-if="$can('read', 'ROSTER')"
            :link="{
              name: $t('message.roster'),
              path: '/management/roster'
            }"
          />
          <sidebar-item
            v-if="$can('read', 'ROSTER')"
            :link="{
              name: $t('message.rosterV2'),
              path: '/management/roster-v2',
              mini: 'RV2'
            }"
          />
          <sidebar-item
            v-if="$can('read', 'EMPLOYEES')"
            :link="{
              name: $t('message.employees'),
              path: '/management/employees'
            }"
          />
          <sidebar-item
            v-if="$can('read', 'RESOURCES')"
            :link="{
              name: $t('message.resources'),
              path: '/management/resources'
            }"
          />
          <sidebar-item
            v-if="$can('read', 'SERVICES')"
            :link="{
              name: $t('message.services'),
              path: '/management/services'
            }"
          />
        </sidebar-item>
        <sidebar-item
          v-if="$can('read', 'ACCOUNTING')"
          :link="{
            name: 'Accounting',
            icon: 'now-ui-icons business_money-coins'
          }"
        >
          <sidebar-item
            v-if="$can('read', 'INVOICES')"
            :link="{
              name: $t('message.invoices'),
              path: '/invoices'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="$can('read', 'RECURRING_INVOICES')"
            :link="{
              name: $t('message.recurringInvoices'),
              path: '/recurring-invoices'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="$can('read', 'CREDIT_NOTES')"
            :link="{
              name: $t('message.creditNotes'),
              icon: 'now-ui-icons files_paper',
              path: '/credit-notes'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="$can('read', 'CUSTOMERS')"
            :link="{
              name: $t('message.customers'),
              path: '/customers'
            }"
          />
          <sidebar-item
            v-if="$can('read', 'BOOKINGS')"
            :link="{
              name: $t('message.bookingsV2'),
              path: '/accounting/bookings-v2',
              mini: 'BV2'
            }"
          />
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Settings',
            icon: 'now-ui-icons loader_gear'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Business Details',
              path: '/settings/business-details'
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Accounting',
              path: '/settings/accounting'
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
              name: $t('message.rosterSettingsTitle'),
              path: '/settings/rostering'
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Shopfront',
              path: '/settings/shopfront'
            }"
          >
          </sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar @on-logout="handleLogout"></top-navbar>
      <router-view name="header"></router-view>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <router-view></router-view>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import { mapActions, mapGetters } from "vuex";
import { onboardState } from "@/helpers/onboard";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    ZoomCenterTransition
  },
  data() {
    return {
      initialized: false
    };
  },
  computed: {
    ...mapGetters({
      userId: "userId",
      userClaims: "userClaims",
      shop: "shops/shop",
      userSettings: "userSettings",
      billingBlocked: "billingBlocked"
    })
  },
  methods: {
    ...mapActions(["logout", "fetchSubscription", "fetchUserSettings"]),
    ...mapActions({ fetchShop: "shops/fetchShop" }),
    handleLogout() {
      this.logout()
        .then(() => this.$router.push("/auth/login"))
        .catch(() => this.$router.push("/auth/login"));
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    async initialize() {
      this.loader = this.$loading.show();
      try {
        await this.fetchSubscription();
        await this.fetchUserSettings();
        await this.fetchShop();

        const shopId = this.shop && (this.shop._id || this.shop.storeId);
        const book = onboardState({
          shop: this.shop,
          settings: this.userSettings,
          userId: this.userId
        });
        if (book === "needed" || !shopId) {
          this.$router.replace("/start");
          return;
        }
        if (
          this.billingBlocked &&
          this.$route.path !== "/account" &&
          this.$route.path !== "/user/subscription"
        ) {
          this.$router.replace({ path: "/start", query: { pay: "1" } });
          return;
        }

        this.initialized = true;
      } catch (error) {
        this.initialized = true;
      } finally {
        if (this.loader) this.loader.hide();
        this.loader = null;
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  },
  async created() {
    this.initialize();
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
